import { UseToastOptions } from "@chakra-ui/toast";

const toastConf: UseToastOptions = {
  duration: 9000,
  isClosable: true,
  position: "top",
};

export const toastSuccess: UseToastOptions = {
  status: "success",
  ...toastConf,
};

export const toastError: UseToastOptions = {
  status: "error",
  ...toastConf,
};

export const toastWarning: UseToastOptions = {
  status: "warning",
  ...toastConf,
};

export default toastConf;
